import React, { useEffect, useRef, useState } from "react";
import { webLoadingFalse, webLoadingTrue, webNavigate } from "../../services/navigate.service";
import LeftIcon from "../../images/LeftIcon";
import ArrowClientsIcon from "../../images/ArrowClientsIcon";
import { validateEmail, validateNoSpecialChars, validateOnlyNumbers } from "../../validation/ValidationInput";
import RoleIcon from "../../images/RoleIcon";
import CheckListIcon from "../../images/CheckListIcon";
import { createRoles, getDetailsRoles, getListRolesPermission, getRoles, updateRoles } from "../../services/roles.service";
import { set } from "react-datepicker/dist/date_utils";
import UserIcon from "../../images/UserIcon";
import UserLocationIcon from "../../images/UserLocationIcon";
import PasswordUserIcon from "../../images/PasswordUserIcon";
import CloseIcon from "../../images/CloseIcon";
import { getLocations } from "../../services/locations.services";
import { createNewUser, getDetailUser, resetPasword, updatreNewUser } from "../../services/company.service";
import PopupLocation from "../../components/PopupLocation";
import { showToast } from "../../services/toast.service";
import { normalizeApiError, showApiError } from "../../services/apiError";
import BackIcon from "../../images/BackIcon";
import CheckIconWhite from "../../images/CheckIconWhite";
import InforLoginIcon from "../../images/InforLoginIcon";
import { useResponsive } from "../../hook/useResponsive";
import { useDialogFocus, useFormKeyboard } from "../../hook/useFormKeyboard";
import { useAccessContext } from "../../hook/useAccessContext";
import { showCustomerAccessField } from "../../services/accessContext";
import { getPlatformStaff, updatePlatformStaff } from "../../services/platform.service";

// The InnovX support grant of an InnovX user ('' = no customer access).
interface CustomerAccessState {
    status: 'idle' | 'loading' | 'ready' | 'hidden' | 'error';
    initial: string;
    value: string;
    roles: { id: string; roleName: string }[];
}
const NO_CUSTOMER_ACCESS: CustomerAccessState = { status: 'idle', initial: '', value: '', roles: [] };

// Hand-rolled option list: Enter saves only when the closed list's text is the last committed label; otherwise it
// picks (highlight, exact name, lone prefix match) or keeps the list open. Tab picks, Escape closes.
function listKeyDown<T>(
    e: React.KeyboardEvent<HTMLInputElement>,
    list: { open: boolean; setOpen: (open: boolean) => void; items: T[]; all: T[]; committed: string; label: (item: T) => string; highlight: number; setHighlight: React.Dispatch<React.SetStateAction<number>>; pick: (item: T) => void },
) {
    const { key } = e;
    const highlighted = list.items[list.highlight];
    const typed = e.currentTarget.value.trim().toLowerCase();
    const exact = list.all.find(item => list.label(item).trim().toLowerCase() === typed);
    if (key === 'ArrowDown' || key === 'ArrowUp') {
        e.preventDefault();
        if (!list.open) {
            list.setHighlight(-1);
            list.setOpen(true);
            return;
        }
        list.setHighlight(i => key === 'ArrowDown' ? Math.min(list.items.length - 1, i + 1) : Math.max(0, i - 1));
    } else if (key === 'Enter' && !e.ctrlKey && !e.metaKey) {
        if (!list.open && typed === list.committed.trim().toLowerCase()) return;
        e.preventDefault();
        const lone = list.items.length === 1 && list.label(list.items[0]).toLowerCase().startsWith(typed) ? list.items[0] : undefined;
        const match = highlighted ?? exact ?? lone;
        if (match) list.pick(match);
        else {
            list.setHighlight(-1);
            list.setOpen(true);
        }
    } else if (!list.open) {
        return;
    } else if (key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        list.setOpen(false);
    } else if (key === 'Tab') {
        const match = highlighted ?? exact;
        if (match) list.pick(match);
        else list.setOpen(false);
    }
}

const UserCompany = () => {
    const [formValues, setFormValues] = useState<any>({});
    const initalFilter = {
        page: 1,
        limit: 50,
        searchValue: "",
        sort: "DESC"
    }
    const preLanguage = localStorage.getItem("language");
    const { isMobile, getWidth } = useResponsive();
    const [language, setLanguage] = useState<any>(null);
    const [errMessage, setErrMessage] = useState<any>("");
    const [filter, setFilter] = useState<any>(initalFilter)
    const [listPermission, setListPermission] = useState<any>([]);
    const [listLocation, setListLocation] = useState<any>([]);
    const userId: string = localStorage.getItem("userId") || "";
    const [userIdUpdate, setUserIdUpdate] = useState<any>("");
    const companyId: string = localStorage.getItem("companyId") || "";
    const dropdownRoleRef = useRef<HTMLDivElement>(null);
    const [searchRole, setSearchRole] = useState("");
    const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
    const [roleHighlight, setRoleHighlight] = useState(-1);
    const [roles, setRoles] = useState<any[]>([]);
    const dropdownMFARef = useRef<HTMLDivElement>(null);
    // The labels the Role and MFA fields last showed from a load or a pick (Enter on them unchanged saves).
    const committedRole = useRef("");
    const committedMfa = useRef("");
    const [searchMFA, setSearchMFA] = useState("");
    const [isMFADropdownOpen, setIsMFADropdownOpen] = useState(false);
    const [mfaHighlight, setMfaHighlight] = useState(-1);
    const [message, setMessage] = useState("")
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const [MFAs, setMFAs] = useState<any[]>([
        {
            id: 1,
            name: "True",
            value: true
        },
        {
            id: 2,
            name: "False",
            value: false
        }
    ]);
    const [errors, setErrors] = useState<any>({});
    const [showPopupReset, setshowPopupReset] = useState<boolean>(false);
    const path = window.location.pathname;
    const id: string = path.split('/').pop() || "";
    const kb = useFormKeyboard({ autoFocus: id === "new" && !isMobile });
    const access = useAccessContext();
    const canSetCustomerAccess = showCustomerAccessField(access, id);
    const [customerAccess, setCustomerAccess] = useState<CustomerAccessState>(NO_CUSTOMER_ACCESS);
    const resetDialogRef = useRef<HTMLDivElement>(null);
    useDialogFocus(showPopupReset, resetDialogRef, () => setshowPopupReset(false));
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const { name, value, type } = e.target;
        setFormValues({ ...formValues, [name]: value })
    }

    useEffect(() => {
        if (id !== "new") {
            fetchData(id);
        } else {
            getListLocations();
        }
        getListRole();
        const handleNewToken = () => {
            if (id !== "new") {
                fetchData(id);
            } else {
                getListLocations();
            }
            getListRole();
        };
        document.addEventListener("newToken", handleNewToken);
        return () => {
            document.removeEventListener("newToken", handleNewToken);
        };
    }, [path]);
    useEffect(() => {
        if (window.languageContext) {
            setLanguage(window.languageContext.language);
        }
    }, [window, window.languageContext]);
    const handleClosePopup = () => {
        setShowPopup(false);
    };
    const handleOpenPopup = () => {
        setShowPopup(true);
    };
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRoleRef.current && !dropdownRoleRef.current.contains(event.target as Node)) {
                setIsRoleDropdownOpen(false);
            }
            if (dropdownMFARef.current && !dropdownMFARef.current.contains(event.target as Node)) {
                setIsMFADropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const getListRole = async () => {
        webLoadingFalse();
        try {
            const response: any = await getRoles(filter);
            // Support roles apply only inside customer companies, set under Customer access.
            setRoles((response.data.data ?? []).filter((role: any) => role?.roleScope !== 'support'))

        } catch (error) {
            console.error("Error loading terms:", error);
        } finally {
            webLoadingFalse()
        }
    };
    const getListLocations = async () => {
        webLoadingFalse();
        try {
            const response: any = await getLocations(userId, companyId, filter.page, filter.limit, filter.searchValue);
            setListPermission(response.data.data.map((item: any) => ({ ...item, value: false })));

        } catch (error) {
            console.error("Error loading terms:", error);
        } finally {
        }
    }
    const fetchData = async (id: any) => {
        webLoadingTrue();
        try {
            const response: any = await getDetailUser(companyId, id);
            console.log("🚀 ~ fetchData ~ response:", response)
            setFormValues(response.data.data.user);
            setUserIdUpdate(response?.data?.data?.userId)
            setSearchRole(response.data.data.userRole.roleName);
            setSearchMFA(response.data.data.mfaEnabled ? "True" : "False");
            committedRole.current = response.data.data.userRole.roleName ?? "";
            committedMfa.current = response.data.data.mfaEnabled ? "True" : "False";
            const responseLocation: any = await getLocations(userId, companyId, filter.page, filter.limit, filter.searchValue);
            const locationRes: any = response.data.userLocationMap;
            const listLiocationRes = responseLocation.data.data.map((item: any) => ({ ...item, value: false }));
            listLiocationRes.forEach((item: any, index: number) => {
                const matchedLocation = locationRes.find((dbLocation: any) => dbLocation.locationId === item.id);
                if (matchedLocation) {
                    listLiocationRes[index].value = true;
                }
            })
            setListPermission(listLiocationRes);
        } catch (error) {
            console.error("Error loading terms:", error);
        } finally {
            webLoadingFalse();
        }
    }

    // Loaded only for InnovX staff-access managers; the API checks the caller and the target again.
    useEffect(() => {
        const target = String(userIdUpdate || '');
        if (!canSetCustomerAccess || !target) {
            setCustomerAccess(NO_CUSTOMER_ACCESS);
            return;
        }
        let alive = true;
        setCustomerAccess({ ...NO_CUSTOMER_ACCESS, status: 'loading' });
        Promise.all([
            getPlatformStaff(target),
            getRoles({ page: 1, limit: 50, searchValue: '', scope: 'support' }),
        ])
            .then(([staffResponse, rolesResponse]: any[]) => {
                if (!alive) return;
                const grant = staffResponse?.data?.data ?? {};
                const current = grant.isActive === true && typeof grant.supportRoleId === 'string' ? grant.supportRoleId : '';
                const roles = (rolesResponse?.data?.data ?? [])
                    .filter((role: any) => role && typeof role.id === 'string')
                    .map((role: any) => ({ id: role.id, roleName: String(role.roleName ?? '') }));
                if (current && !roles.some((role: { id: string }) => role.id === current)) {
                    roles.unshift({ id: current, roleName: String(grant.supportRoleName ?? current) });
                }
                setCustomerAccess({ status: 'ready', initial: current, value: current, roles });
            })
            .catch((error: any) => {
                if (!alive) return;
                const status = normalizeApiError(error).status;
                // 400/403/404: this person cannot hold customer access, so the field is not offered.
                setCustomerAccess({ ...NO_CUSTOMER_ACCESS, status: status >= 400 && status < 500 ? 'hidden' : 'error' });
            });
        return () => {
            alive = false;
        };
    }, [canSetCustomerAccess, userIdUpdate]);

    const handleToggle = (index: any) => {
        const temp: any = [...listPermission];
        temp[index].value = !temp[index].value;
        setListPermission([...temp]);
    };
    const handleRoleSelect = (roleId: string, roleNamme: string) => {
        setFormValues((prev: any) => ({ ...prev, userRoleId: roleId }));
        setSearchRole(roleNamme);
        committedRole.current = roleNamme;
        setIsRoleDropdownOpen(false);
    };
    const handleMFASelect = (mfaEnabled: boolean, mfaName: string) => {
        setFormValues((prev: any) => ({ ...prev, mfaEnabled: mfaEnabled }));
        setSearchMFA(mfaName);
        committedMfa.current = mfaName;
        setIsMFADropdownOpen(false);
    };

    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        const newErrors: any = {};
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(formValues.emailAddress)) {
            newErrors.emailAddress = 'Email must be valid';
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        const temp: any = listPermission.filter((item: any) => item.value === true)
        webLoadingTrue();
        const payload: any = {
            ...formValues,
            location: temp.map(({ id }: any) => ({ id })),
            companyId,
            lastLogin: formValues?.lastLogin ? formValues?.lastLogin : new Date(),
            passwordHash: formValues?.passwordHash ? formValues?.passwordHash : ""
        }
        if (id === "new") {
            try {
                const response: any = await createNewUser(payload);
                webNavigate("/" + preLanguage + "/companies" + "?tab=user");
                webLoadingFalse();
                showToast({
                    message: "Create new user successfull!",
                    type: 'success',
                    duration: 20000,
                });
            } catch (error: any) {
                webLoadingFalse();
                setErrMessage(showApiError(error, { language, setFieldErrors: setErrors }).message)
            }
        } else {
            try {
                const response: any = await updatreNewUser(companyId, userIdUpdate, payload);
                if (response?.data?.id) {
                    if (canSetCustomerAccess && customerAccess.status === 'ready' && customerAccess.value !== customerAccess.initial) {
                        try {
                            await updatePlatformStaff(String(userIdUpdate), customerAccess.value || null);
                            setCustomerAccess((prev) => ({ ...prev, initial: prev.value }));
                        } catch (error: any) {
                            webLoadingFalse();
                            setErrMessage(showApiError(error, { language }).message);
                            return;
                        }
                    }
                    webNavigate("/" + preLanguage + "/companies" + "?tab=user");
                    webLoadingFalse();
                    showToast({
                        message: "Update new user successfull!",
                        type: 'success',
                        duration: 20000,
                    });
                }
            } catch (error: any) {
                webLoadingFalse();
                setErrMessage(showApiError(error, { language, setFieldErrors: setErrors }).message)
            }
        }
    }
    const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${day}/${month}/${year} at ${hours}:${minutes}`;
    }
    const handleSendPasswordReset = async () => {
        setshowPopupReset(false);
        try {
            const response = await resetPasword({ email: formValues?.emailAddress || "" });
            if (response.data.success) {
                setErrMessage("Email verification sented, please check email !");
                showToast({
                    message: "Email verification sent, please check your email!",
                    type: 'success',
                    duration: 20000,
                });
            }
        } catch (error: any) {
            console.error('Signup failed:', error);
            setshowPopupReset(false);
            setErrMessage(showApiError(error, { language, setFieldErrors: setErrors, fieldAliases: { email: "emailAddress" } }).message);
        }
    }
    const filteredRoles = isRoleDropdownOpen
        ? roles.filter(role =>
            role.roleName.toLowerCase().includes(searchRole.toLowerCase())
        )
        : [];
    const filteredMFAs = isMFADropdownOpen
        ? MFAs.filter(value =>
            value.name.toLowerCase().includes(searchMFA.toLowerCase())
        )
        : [];
    return (
        <div {...kb.scopeProps}>
            <div className="bg-white" style={{}}>
                <div className="flex items-center ">
                    <button
                        type="button"
                        aria-label={language?.['Back'] ?? 'Back'}
                        className="w-6 h-6 flex items-center justify-center cursor-pointer"
                        onClick={() => { webNavigate("/" + preLanguage + '/companies' + "?tab=user") }}
                    >
                        <BackIcon />
                    </button>
                    <p
                        style={{ fontSize: '14px', fontWeight: '500', lineHeight: '28px', color: '#222525' }}
                        className="font-inter"
                    >
                        {language && language?.['Back'] ? language?.['Back'] : 'Back'}
                    </p>
                </div>
            </div>
            <div className="flex items-start scroll-container" style={{ gap: "20px", height: 'calc(100% - 119px)', flexWrap: "wrap", overflow: 'scroll', marginTop: isMobile ? "24px" : "0px" }}>
                <div style={{ width: isMobile ? "100%" : "calc(32% - 10px)" }}>
                    <div style={{ width: '100%', padding: "20px", border: '1px solid #DBE4E4', borderRadius: '12px' }}>
                        <div className="flex items-center gap-x-2">
                            <div className="w-6 h-6 flex items-center justify-center">
                                <UserLocationIcon />
                            </div>
                            <p className="font-inter " style={{ fontSize: '16px', fontWeight: "500", lineHeight: "130%", color: "#222525" }}>
                                {language?.['Location access'] ?? 'Location access'}
                            </p>
                        </div>
                        <div style={{ marginTop: "20px" }} className="">
                            {listPermission.map((val: any, index: any) => {
                                return (
                                    <div className="flex items-center" style={{ marginTop: "20px", gap: '8px' }}>
                                        <button
                                            type="button"
                                            role="checkbox"
                                            aria-checked={!!val?.value}
                                            aria-label={val?.name}
                                            // A checkbox toggles on Space only, so Enter must not press it.
                                            onKeyDown={(e) => { if (e.key === 'Enter' && !e.ctrlKey && !e.metaKey) e.preventDefault(); }}
                                            onClick={() => { handleToggle(index) }}
                                            style={{
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '6px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                transition: 'all 0.2s',
                                                backgroundColor: val?.value ? '#0F7679' : 'white',
                                                border: val?.value ? 'none' : '2px solid #d1d5db',
                                                color: 'white'
                                            }}
                                        >
                                            {val?.value && <CheckIconWhite />}
                                        </button>
                                        <div >
                                            <p className="text-[14px] leading-[20px] font-inter font-medium" style={{ color: "#222525" }}>{val?.name}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div style={{ width: '100%', padding: "20px", border: '1px solid #DBE4E4', borderRadius: '12px', margin: '12px 0px' }}>
                        <div className="flex items-center gap-x-2">
                            <div className="w-6 h-6 flex items-center justify-center">
                                <PasswordUserIcon />
                            </div>
                            <p className="font-inter " style={{ fontSize: '16px', fontWeight: "500", lineHeight: "130%", color: "#222525" }}>{language?.['Manage password'] ?? 'Manage password'}</p>
                        </div>
                        <div className="" style={{ gap: "12px", marginTop: "20px" }}>
                            <button type="button" className="font-inter cursor-pointer" style={{ width: 'fit-content', padding: "10px 23px", borderRadius: "30px", backgroundColor: "white", border: "1px solid #0F7679", fontSize: "14px", lineHeight: "22px", color: '#0F7679', fontWeight: "500" }} onClick={() => { setshowPopupReset(true) }}>{language?.['Reset Password'] ?? 'Reset Password'}</button>
                        </div>
                    </div>
                    {
                        formValues?.passwordDate &&
                        <div style={{ width: '100%', padding: "20px", border: '1px solid #DBE4E4', borderRadius: '12px' }}>
                            <div className="flex items-center gap-x-2">
                                <div className="w-6 h-6 flex items-center justify-center">
                                    <InforLoginIcon />
                                </div>
                                <p className="font-inter " style={{ fontSize: '16px', fontWeight: "500", lineHeight: "130%", color: "#222525" }}>{language?.['Last login'] ?? 'Last login'}</p>
                            </div>
                            <div className="" style={{ gap: "12px", marginTop: "20px" }}>
                                {formValues?.passwordDate &&
                                    <div >
                                        <p className="font-inter" style={{ fontSize: "14px", fontWeight: "500", color: "#6A7878", lineHeight: "20.8px" }}>{formValues?.passwordDate ? formatDate(formValues?.passwordDate) : ""}</p>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
                <div style={{ width: isMobile ? "100%" : "calc(67% - 10px)", }}>
                    <div style={{ width: "100%" }}>
                        {
                            id === "new" ?
                                <p
                                    style={{
                                        fontSize: '20px',
                                        fontWeight: '500',
                                        lineHeight: '28px',
                                        color: '#222525',
                                    }}
                                    className="font-inter"
                                >
                                    {language && language?.[`Add user details`] ? language?.[`Add user details`] : `Add user details`}
                                </p>
                                :
                                <p
                                    style={{
                                        fontSize: '20px',
                                        fontWeight: '500',
                                        lineHeight: '28px',
                                        color: '#222525',
                                    }}
                                    className="font-inter"
                                >
                                    {language && language?.[`Edit user details`] ? language?.[`Edit user details`] : `Edit location details`}
                                </p>
                        }
                        <div >
                            <div className="flex items-center" style={{ gap: "24px", flexWrap: 'wrap', marginTop: isMobile ? "24px" : "0px" }}>
                                <div className="space-y-2" style={{ width: "calc(100% - 12px)" }}>
                                    <div className="flex items-center justify-between">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language?.['First Name'] ?? 'First Name'}</p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="firstName"
                                            onKeyDown={validateNoSpecialChars}
                                            value={formValues?.firstName}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                    </div>
                                    {errors.firstName && <p className="error">{errors.firstName}</p>}
                                </div>
                                <div className="space-y-2" style={{ width: "calc(100% - 12px)" }}>
                                    <div className="flex items-center justify-between">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language?.['Last Name'] ?? 'Last Name'}</p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="lastName"
                                            onKeyDown={validateNoSpecialChars}
                                            value={formValues?.lastName}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                    </div>
                                    {errors.lastName && <p className="error">{errors.lastName}</p>}
                                </div>
                                <div className="space-y-2" style={{ width: "100%" }}>
                                    <div className="flex items-center">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language?.["Email address"] ?? "Email address"}</p>
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                                            {language && language?.['*'] ? language?.['*'] : '*'}
                                        </p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="emailAddress"
                                            value={formValues?.emailAddress}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                    </div>
                                    {errors.emailAddress && <p className="error">{errors.emailAddress}</p>}
                                </div>
                                <div className="space-y-2" style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}>
                                    <div className="flex items-center justify-between">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language?.['User code'] ?? 'User code'}</p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="userCode"
                                            value={formValues?.userCode}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                    </div>
                                    {errors.userCode && <p className="error">{errors.userCode}</p>}
                                </div>
                                <div className="space-y-2" style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}>
                                    <div className="flex items-center justify-between">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language?.['Phone Number'] ?? 'Phone Number'}</p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="phoneNumber"
                                            onKeyDown={validateNoSpecialChars}
                                            value={formValues?.phoneNumber}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                    </div>
                                    {errors.phoneNumber && <p className="error">{errors.phoneNumber}</p>}
                                </div>
                                <div className="w-full space-y-2" style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}>
                                    <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language?.['User Role'] ?? 'User Role'}</p>
                                    <div className="relative" ref={dropdownRoleRef}>
                                        <input
                                            type="text"
                                            value={searchRole}
                                            role="combobox"
                                            aria-expanded={isRoleDropdownOpen}
                                            aria-autocomplete="list"
                                            onChange={(e) => {
                                                setSearchRole(e.target.value);
                                                setRoleHighlight(-1);
                                                setIsRoleDropdownOpen(true);
                                            }}
                                            onClick={() => {
                                                setRoleHighlight(-1);
                                                setIsRoleDropdownOpen(true);
                                            }}
                                            onKeyDown={(e) => {
                                                validateNoSpecialChars(e);
                                                listKeyDown(e, {
                                                    open: isRoleDropdownOpen, setOpen: setIsRoleDropdownOpen, items: filteredRoles, label: (v: any) => v.roleName,
                                                    all: roles, committed: committedRole.current,
                                                    highlight: roleHighlight, setHighlight: setRoleHighlight, pick: (v: any) => handleRoleSelect(v.id, v.roleName),
                                                });
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        {isRoleDropdownOpen && (
                                            <div className="absolute z-10 w-full mt-1 bg-white border border-[#EBEBED] rounded-md shadow-lg max-h-60 overflow-auto">
                                                {filteredRoles
                                                    .map((v, index) => (
                                                        <div
                                                            key={v.id}
                                                            ref={index === roleHighlight ? (el) => el?.scrollIntoView({ block: 'nearest' }) : undefined}
                                                            className="px-4 py-2 cursor-pointer hover:bg-[#E7F1F1] text-main"
                                                            style={index === roleHighlight ? { backgroundColor: '#E7F1F1' } : undefined}
                                                            onMouseDown={(e) => e.preventDefault()}
                                                            onClick={() => handleRoleSelect(v.id, v.roleName)}
                                                        >
                                                            {v.roleName}
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="w-full space-y-2" style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}>
                                    <div className="flex items-center">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language?.['MFA Enabled'] ?? 'MFA Enabled'}</p>
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                                            {language && language?.['*'] ? language?.['*'] : '*'}
                                        </p>
                                    </div>
                                    <div className="relative" ref={dropdownMFARef}>
                                        <input
                                            type="text"
                                            value={searchMFA}
                                            role="combobox"
                                            aria-expanded={isMFADropdownOpen}
                                            aria-autocomplete="list"
                                            onChange={(e) => {
                                                setSearchMFA(e.target.value);
                                                setMfaHighlight(-1);
                                                setIsMFADropdownOpen(true);
                                            }}
                                            onClick={() => {
                                                setMfaHighlight(-1);
                                                setIsMFADropdownOpen(true);
                                            }}
                                            onKeyDown={(e) => {
                                                validateNoSpecialChars(e);
                                                listKeyDown(e, {
                                                    open: isMFADropdownOpen, setOpen: setIsMFADropdownOpen, items: filteredMFAs, label: (v) => v.name,
                                                    all: MFAs, committed: committedMfa.current,
                                                    highlight: mfaHighlight, setHighlight: setMfaHighlight, pick: (v) => handleMFASelect(v.value, v.name),
                                                });
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        {isMFADropdownOpen && (
                                            <div className="absolute z-10 w-full mt-1 bg-white border border-[#EBEBED] rounded-md shadow-lg max-h-60 overflow-auto">
                                                {filteredMFAs
                                                    .map((v, index) => (
                                                        <div
                                                            key={v.id}
                                                            ref={index === mfaHighlight ? (el) => el?.scrollIntoView({ block: 'nearest' }) : undefined}
                                                            className="px-4 py-2 cursor-pointer hover:bg-[#E7F1F1] text-main"
                                                            style={index === mfaHighlight ? { backgroundColor: '#E7F1F1' } : undefined}
                                                            onMouseDown={(e) => e.preventDefault()}
                                                            onClick={() => handleMFASelect(v.value, v.name)}
                                                        >
                                                            {v.name}
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {canSetCustomerAccess && customerAccess.status !== 'idle' && customerAccess.status !== 'hidden' && (
                                    <div style={{ width: "100%" }}>
                                        <label htmlFor="user-customer-access" className="font-inter" style={{ display: "block", fontSize: "14px", lineHeight: "20px", fontWeight: 500, color: "#4A5353", marginBottom: "8px" }}>
                                            {language?.['Customer access'] ?? 'Customer access'}
                                        </label>
                                        <select
                                            id="user-customer-access"
                                            value={customerAccess.value}
                                            disabled={customerAccess.status !== 'ready'}
                                            aria-describedby="user-customer-access-hint"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setCustomerAccess((prev) => ({ ...prev, value }));
                                            }}
                                            className="font-inter"
                                            style={{ display: "block", width: "100%", boxSizing: "border-box", padding: "12px", fontSize: "14px", color: "#222525", backgroundColor: "#FFFFFF", border: "1px solid #EBEBED", borderRadius: "12px", cursor: customerAccess.status === 'ready' ? "pointer" : "default" }}
                                        >
                                            <option value="">{language?.['None'] ?? 'None'}</option>
                                            {customerAccess.roles.map((role) => (
                                                <option key={role.id} value={role.id}>{role.roleName}</option>
                                            ))}
                                        </select>
                                        <p id="user-customer-access-hint" className="font-inter" style={{ margin: "6px 0 0", fontSize: "13px", lineHeight: "18px", color: "#6A7878" }}>
                                            {language?.['What this person can do inside customer companies. Their role above is for InnovX itself.'] ?? 'What this person can do inside customer companies. Their role above is for InnovX itself.'}
                                        </p>
                                        {customerAccess.status === 'loading' && (
                                            <p className="font-inter" style={{ margin: "6px 0 0", fontSize: "13px", color: "#6A7878" }}>{language?.['Loading customer access…'] ?? 'Loading customer access…'}</p>
                                        )}
                                        {customerAccess.status === 'error' && (
                                            <p role="alert" className="font-inter" style={{ margin: "6px 0 0", fontSize: "13px", color: "#BA0E13" }}>{language?.['Customer access could not be loaded. Reload the page to try again.'] ?? 'Customer access could not be loaded. Reload the page to try again.'}</p>
                                        )}
                                        {customerAccess.status === 'ready' && customerAccess.value !== customerAccess.initial && (
                                            <p className="font-inter" style={{ margin: "6px 0 0", fontSize: "13px", color: "#4A5353" }}>{language?.['Saving this change signs them out of every device.'] ?? 'Saving this change signs them out of every device.'}</p>
                                        )}
                                    </div>
                                )}
                                <div className="space-y-2" style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}>
                                    <div className="flex items-center justify-between">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language?.['Last login'] ?? 'Last login'}</p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            disabled={true}
                                            type="text"
                                            name="lastLogin"
                                            style={{ backgroundColor: "#F9F9F9", border: "1px solid #E7F1F1" }}
                                            onKeyDown={validateNoSpecialChars}
                                            value={formValues?.lastLogin ? formatDate(formValues?.lastLogin) : ""}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main  p-3 rounded-lg  outline-none focus-none  w-full`}
                                        />
                                    </div>
                                    {errors.lastLogin && <p className="error">{errors.lastLogin}</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="w-full flex items-center justify-end shadow_button relative"
                style={{ gap: "12px", paddingTop: "24px", }}
            >
                <div className="absolute" style={{ left: "-24px", top: 0, height: "1px", backgroundColor: "#DBE4E4", width: isMobile ? 'calc(100vw + 32px)' : "calc(-256px + 48px + 100vw)" }}></div>
                <button
                    type="button"
                    onClick={() => { webNavigate("/" + preLanguage + '/companies' + "?tab=user") }}
                    style={{
                        padding: '10px 24px',
                        borderRadius: '30px',
                        color: '#222525',
                        fontSize: '14px',
                        fontWeight: '500',
                        border: '1px solid #C9D7D8',
                    }}
                    className="font-inter cursor-pointer"
                >
                    {language && language?.['Cancel'] ? language?.['Cancel'] : 'Cancel'}
                </button>
                <button type="button" {...kb.primaryProps(handleSubmit)} style={{
                    padding: '10px 24px',
                    borderRadius: '30px',
                    color: '#FFFFFF',
                    fontSize: '14px',
                    fontWeight: '500',
                    backgroundColor: '#0F7679',
                }}
                    className="font-inter cursor-pointer"
                >
                    <p className="text-[14px] leading-[22px] font-inter">{language && language?.["Save"] ? language?.["Save"] : "Save"}</p>
                </button>
            </div>
            <div
                ref={resetDialogRef}
                role="dialog"
                aria-modal="true"
                className={`absolute w-full h-full top-0 left-0 flex items-center justify-center px-4 ${showPopupReset ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} transition-opacity duration-300 ease-in-out`}
                style={{ backgroundColor: "#22252552", zIndex: "200", transition: "opacity 0.3s ease, visibility 0.3s ease", width: "100%", visibility: showPopupReset ? "visible" : "hidden" }}
            >
                <div
                    className={`transform transition-transform duration-300 ease-in-out ${showPopupReset ? "translate-y-0" : "translate-y-4 opacity-0"}`} style={{
                        padding: "24px", borderRadius: "24px", backgroundColor: "white", width: "520px", transition: "transform 0.3s ease, opacity 0.3s ease",
                    }}
                >
                    <div
                        className="flex items-center justify-between"
                    >
                        <span className="text-[16px] font-semibold font-inter text-main leading-[24px]">
                            {language?.['Reset user password'] ?? 'Reset user password'}
                        </span>
                        <button
                            type="button"
                            aria-label={language?.['Close'] ?? 'Close'}
                            onClick={() => { setshowPopupReset(false); }}
                            className="flex items-center justify-center cursor-pointer"
                            style={{
                                width: "24px",
                                height: "24px",
                            }}
                        >
                            <CloseIcon />
                        </button>
                    </div>
                    <div className="" style={{ marginTop: '12px' }}>
                        <span style={{ color: '#6A7878' }} className="text-[14px] font-inter">
                            {language?.['This action will immediately disable their password, preventing login until they reset it. An email will be sent with instructions to create a new password.'] ?? 'This action will immediately disable their password, preventing login until they reset it. An email will be sent with instructions to create a new password.'}
                        </span>
                    </div>
                    {message.length > 0 && <p className="text-base font-bold " style={{ color: "#E40F03" }}>{message}</p>}
                    <div
                        className="w-full flex items-center justify-end"
                        style={{ marginTop: '24px', gap: '12px' }}
                    >
                        <button
                            type="button"
                            onClick={() => { setshowPopupReset(false); }}
                            style={{
                                padding: '10px 24px',
                                borderRadius: '30px',
                                color: '#222525',
                                fontSize: '14px',
                                fontWeight: '500',
                                border: '1px solid #C9D7D8',
                            }}
                            className="font-inter cursor-pointer"
                        >
                            {language && language?.['Cancel'] ? language?.['Cancel'] : 'Cancel'}
                        </button>
                        <button type="button" style={{
                            padding: '10px 24px',
                            borderRadius: '30px',
                            color: '#FFFFFF',
                            fontSize: '14px',
                            fontWeight: '500',
                            backgroundColor: '#BA0E13',
                        }}
                            className="font-inter cursor-pointer"
                            onClick={() => { handleSendPasswordReset(); }}
                        >
                            <p className="text-[14px] leading-[22px] font-inter">{language && language?.["Reset password"] ? language?.["Reset password"] : "Reset password"}</p>
                        </button>
                    </div>
                </div>
            </div>
            <PopupLocation show={showPopup} title={`${id !== "new" ? "Update User" : "Create User"}`} desc={errMessage} onClose={handleClosePopup} onOpen={handleOpenPopup} />
        </div>
    )
}
export default UserCompany;